import { forwardRef } from 'react'

import type { SliderInputProps } from './SliderInput'
import SliderInput from './SliderInput'

const SliderInputPerFlag = forwardRef<HTMLInputElement, SliderInputProps>(
  (props: SliderInputProps, ref) => {
    return <SliderInput {...props} />
  }
)

export type { SliderInputProps }

export default SliderInputPerFlag
